// Academy: the learning game picker.

import { h, clear } from '@kit/dom';
import { GAMES, lockInfo } from '../registry';
import { getSave, gameStars, skill as skillState, subscribe } from '../state';
import { ringFor, SKILL_BY_ID } from '../skills';
import { go } from '../router';
import { topBar, categoryColor, categoryLabel, banner } from '../ui';
import type { GameModule } from '../types';
import { artImg, onArtReady } from '@kit/assets';

export function academyScreen(root: HTMLElement, params: string[] = []) {
  let tab = params[0] && ['all', 'words', 'math', 'science'].includes(params[0]) ? params[0] : (sessionStorage.getItem('academy.tab') || 'all');
  const bar = topBar('Academy', { back: 'hub' });
  const tabs = h('div.tabs');
  const list = h('div.stack', { style: { padding: '0 16px 24px' } });
  root.append(bar);
  const ban = banner('scene.academy'); if (ban) root.append(ban);
  root.append(tabs, list);

  function renderTabs() {
    clear(tabs);
    for (const [id, label] of [['all', 'All'], ['words', 'Words'], ['math', 'Math'], ['science', 'Science']]) {
      tabs.append(h('button.tab' + (tab === id ? '.on' : ''), { onclick: () => { tab = id; sessionStorage.setItem('academy.tab', id); renderTabs(); renderList(); } }, label));
    }
  }

  function renderList() {
    clear(list);
    const games = GAMES.filter(g => g.category !== 'fun' && (tab === 'all' || g.category === tab));
    // open games first, then locked ones by how close they are
    const open = games.filter(g => lockInfo(g).unlocked);
    const locked = games.filter(g => !lockInfo(g).unlocked).sort((a, b) => (lockInfo(a).needStars ?? 0) - (lockInfo(b).needStars ?? 0));
    for (const g of open) list.append(card(g));
    if (locked.length) list.append(h('p.muted.small', { style: { marginTop: '6px' } }, `Coming up (${locked.length}):`));
    for (const g of locked) list.append(card(g));
    if (!games.length) list.append(h('p.muted.center.pad', null, 'Nothing here yet.'));
  }

  function card(g: GameModule): HTMLElement {
    const lock = lockInfo(g);
    const stars = gameStars(g.id);
    const primary = g.skills[0];
    const ring = primary ? ringFor(skillState(primary).rung) : null;
    const kid = primary ? SKILL_BY_ID[primary].kid : '';
    const el = h('div.card.tap' + (lock.unlocked ? '' : '.locked'), {
      onclick: () => { if (lock.unlocked) go(`play/${g.id}`); },
      style: { borderLeft: `8px solid ${g.color || categoryColor(g.category)}` },
    },
      h('div.row', null,
        artImg(`icon.${g.id}`, 56),
        h('div', { style: { flex: '1' } },
          h('h3', null, g.title),
          h('p.muted.small', null, g.blurb),
        ),
        lock.unlocked
          ? h('div.stack.center', { style: { gap: '4px', alignItems: 'center' } },
            ring ? h('span.ring', { style: { color: ring.color, background: ring.color }, title: `${kid}: ${ring.name} ring` }) : null,
            h('span.small', { style: { fontWeight: '800' } }, h('span.dot.star', { style: { display: 'inline-block', verticalAlign: '-2px', marginRight: '4px' } }), String(stars)),
          )
          : h('div.small.center', { style: { fontWeight: '800', minWidth: '70px' } }, lock.needStars ? `${lock.needStars} more` : '', h('br'), lock.needStars ? h('span.dot.star', { style: { display: 'inline-block' } }) : null),
      ),
      h('p.small.muted', { style: { marginTop: '6px' } }, `${categoryLabel(g.category)}${kid ? ' · ' + kid : ''}`),
    );
    return el;
  }

  renderTabs();
  renderList();
  const un = subscribe(() => renderList());
  const unArt = onArtReady(renderList);
  void getSave;
  return () => { un(); unArt(); };
}
